import { Box } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";
import { Outlet } from "react-router-dom";

import PageLayout from "../../components/common/page-layout";
import CrownDataSidebar from "../../components/crown-data-import/crown-data-sidebar";
import { RequireAuth } from "../../hooks/use-auth";

const styles = {
  layout: {
    display: "flex",
    flexDirection: "row",
    // Fills the height PageLayout leaves under the header, so the sidebar's
    // stretch reaches the bottom of the viewport on a short module page
    // instead of stopping at the content's own height.
    flex: 1,
    minHeight: 0,
  },
  content: {
    flex: 1,
    p: 3,
  },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Shell page for the Crown data import hub.
 *
 * Gates access behind `RequireAuth` and renders the sidebar alongside the active
 * module through the router `Outlet`. The target environment comes from the
 * app-wide `EnvProvider` mounted in `index.tsx`.
 */
const CrownDataImportPage = () => {
  return (
    <RequireAuth>
      <PageLayout disableGutters maxWidth={false} title="Crown data import">
        <Box sx={styles.layout}>
          <CrownDataSidebar />
          <Box sx={styles.content}>
            <Outlet />
          </Box>
        </Box>
      </PageLayout>
    </RequireAuth>
  );
};

export default CrownDataImportPage;
